import React, { useState, useEffect, useRef } from "react";

import { Doughnut, Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import ReportsDiamondService from "../../../services/reports-Diamond.service";
import logoImg from "../../../../src/assets/images/logo-img.png";
import UnionIcon from "../../../assets/images/icons/Union_5.svg";
import { BlobToDownloadFile } from "../../../helper/commanFunction";
import { useSelector } from "react-redux";
import moment from "moment";
import { Tooltip } from "chart.js";
import Chart from "react-google-charts";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import {
  Button,
  DatePicker,
  Select,
  Spin,
  Table,
  Tooltip as AntdToolTip,
} from "antd";
import { chartColors } from "../../reports/colors";

const { RangePicker } = DatePicker;
const { Option } = Select;

const DiamondReportsChartsIndComp = () => {
  const { t } = useTranslation();
  const chartRef = useRef(null);
  const chartRefPie = useRef(null);
  /*Initial State for Binding Starts*/
  const initialGlobalDiamondState = {
    dataRangeFrom: moment().subtract(30, "days").format("YYYY-MM-DD"),
    dataRangeTo: moment().format("YYYY-MM-DD"),
    SelectedDiamondValue: "All",
    retailerIds: [],
    vendorIds: [],
  };
  /*Initial State for Binding Ends*/

  /*React Binding Starts*/
  const [TableChartList, setTableChartList] = useState([]);
  const [TableDiamondChartList, setTableDiamondChartList] = useState([]);
  const [globalDiamonds, setGlobalDiamond] = useState(
    initialGlobalDiamondState
  );
  const [LoadChartReportsLoading, setLoadChartReportsLoading] = useState(false);
  const [TableForDiamChartLoading, setTableForDiamChartLoading] =
    useState(false);
  const [TableChartLoading, setTableChartLoading] = useState(false);
  const [TotalDiamondClicks, setTotalDiamondClicks] = useState(0);
  const [dealerId, setDealerId] = useState();
  const [forDealer, setForDealer] = useState("");
  const loginDetials = useSelector((state) => state.loginReducer);
  const [diamondReportsChartLabels, setDiamondReportsChartLabels] = useState(
    []
  );
  const [DiamondReportsChartList, setDiamondReportsChartList] = useState([]);
  const [ReportsDiamondChartColorData, setReportsDiamondChartColorData] =
    useState([]);
  const [DiamondReportsChartYAxisList, setDiamondReportsChartYAxisList] =
    useState([]);
  const [totalValueForPercentage, setTotalValueForPercentage] = useState(0);
  const [TooltipPercentage, setTooltipPercentage] = useState("");
  const [colorData, setColorData] = useState([]);
  const [downloadCSVDataloading, setDownloadCSVDataloading] = useState(false);
  const [downloadPDFDataloading, setDownloadPDFDataloading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [totalCount, setTotalCount] = useState(0);
  const [EventsCount, setEventsCount] = useState(0);
  const [TotalEventsCount, setTotalEventsCount] = useState(0);
  const [sortType, setSortType] = useState("desc");
  const [sortColumnName, setSortColumnName] = useState("GT.MODIFIED");
  const [key, setKey] = useState(true);
  const [pieChartInstance, setPieChartInstance] = useState(null);
  const [barChartInstance, setBarChartInstance] = useState(null);

  // New states for processed chart data
  const [pieChartData, setPieChartData] = useState([]);
  const [pieColorData, setPieColorData] = useState([]);
  const [barChartData, setBarChartData] = useState([]);
  const [barColorData, setBarColorData] = useState([]);

  // Configuration
  const MAX_ENTRIES = 15; // Maximum entries to show

  /*DatePicker Binding Starts*/
  const onDateChange = (dates, dateStrings) => {
    if (dates) {
      setGlobalDiamond((prevState) => ({
        ...prevState,
        dataRangeFrom: moment.utc(dates[0]).toISOString(),
        dataRangeTo: moment.utc(dates[1]).toISOString(),
      }));
    }
  };

  /*DatePicker Binding Ends*/
  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleCheckDealermembers(
            loginDetials.loginDetials.responseData.dealerId
          );
        }
      }
    }
    Tooltip.positioners.custom = function (elements, position) {
      return {
        x: position.x,
        y: position.y + 10,
      };
    };
    chartDataHandler(ReportsDiamondChartColorData);
  }, []);

  function chartDataHandler(arr) {
    const color = [];
    for (let i = 0; i < arr.length; i++) {
      color.push("#" + Math.floor(Math.random() * 16777215).toString(16));
    }
    setColorData(color);
  }

  // Process chart data with max entries limit
  const processChartData = (chartList, yAxisList, labels) => {
    if (!chartList?.length || !yAxisList?.length || !labels?.length) {
      return { chartData: [], colors: [] };
    }

    // Create data array with labels and values
    const dataWithValues = labels.map((label, index) => ({
      label,
      value: yAxisList[index],
      originalIndex: index,
    }));

    // Filter out zero values and sort by value (descending)
    const filteredData = dataWithValues.filter((item) => item.value > 0);
    const sortedData = [...filteredData].sort((a, b) => b.value - a.value);

    // Apply max entries limit
    const topData = sortedData.slice(0, MAX_ENTRIES);
    const remainingData = sortedData.slice(MAX_ENTRIES);

    // Calculate "Others" if needed
    const othersValue = remainingData.reduce(
      (sum, item) => sum + item.value,
      0
    );
    if (othersValue > 0 && remainingData.length > 0) {
      topData.push({
        label: t("Others"),
        value: othersValue,
        isOthers: true,
      });
    }

    // Calculate total for percentages
    const total = topData.reduce((sum, item) => sum + item.value, 0);

    // Prepare chart data
    const processedChartData = [["Vendor", "Diamond Clicks"]];
    const colors = [];

    topData.forEach((item, index) => {
      const percentage =
        total > 0 ? ((item.value / total) * 100).toFixed(1) : 0;
      const color = item.isOthers
        ? "#CCCCCC"
        : chartColors[index % chartColors.length];
      colors.push(color);

      processedChartData.push([`${item.label} (${percentage}%)`, item.value]);
    });

    return { chartData: processedChartData, colors };
  };

  /*API Binding Starts*/
  const handleCheckDealermembers = (id) => {
    try {
      let inputData = {
        dealerID: id,
      };

      ReportsDiamondService.CheckDealermembers(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          debugger

          // Calculate forDealer based on dealerMemberTypeName
          let forDealer;
          if (
            loginDetials.loginDetials.responseData.dealerMemberTypeName ===
              "VendorDiamond" ||
            loginDetials.loginDetials.responseData.dealerMemberTypeName === "Vendor"
          ) {
            forDealer = 1;
          } else if (
            loginDetials.loginDetials.responseData.dealerMemberTypeName ===
              "Retailer" ||
            loginDetials.loginDetials.responseData.dealerMemberTypeName === "Combined"
          ) {
            forDealer = 2;
          } else {
            forDealer = 3;
          }

          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              setForDealer(forDealer);
            } else {
              setForDealer("");
            }
            handleGetDiamondColumnChartData(id, forDealer);
            handleGetDiamondReportForTableChart(id, forDealer);
            handleDimondChart_SortingBindData(
              id,
              forDealer,
              pageNo,
              pageSize,
              sortColumnName,
              sortType
            );
          } else {
            setForDealer("");
          }
        })
        .catch((error) => {
          setForDealer("");
        });
    } catch (error) {
      setForDealer("");
    }
  };

  const handleGetDiamondColumnChartData = (dealerId, forDealer) => {
    if (
      loginDetials.loginDetials.responseData.dealerMemberTypeName ===
        "VendorDiamond" ||
      loginDetials.loginDetials.responseData.dealerMemberTypeName === "Vendor"
    ) {
      forDealer = 1;
    } else if (
      loginDetials.loginDetials.responseData.dealerMemberTypeName ===
        "Retailer" ||
      loginDetials.loginDetials.responseData.dealerMemberTypeName === "Combined"
    ) {
      forDealer = 2;
    } else {
      forDealer = 3;
    }
    try {
      let inputData = {
        dealerID: dealerId.toString(),
        forDealer: forDealer ? forDealer.toString() : "",
        fromDate: globalDiamonds.dataRangeFrom
          ? globalDiamonds.dataRangeFrom
          : "2020-08-17",
        toDate: globalDiamonds.dataRangeTo
          ? globalDiamonds.dataRangeTo
          : "2022-09-15",
        selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
      };
      setLoadChartReportsLoading(true);
      ReportsDiamondService.GetDiamondColumnChartData(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var DiamondReportsChartList = responseData.Table;
          setLoadChartReportsLoading(false);
          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              setDiamondReportsChartList(DiamondReportsChartList);
              var DiamondReportsChartLabelArr = DiamondReportsChartList.map(
                (item) => {
                  return item.DealerCompany;
                }
              );
              var DiamondReportsChartYAxisList = DiamondReportsChartList.map(
                (item) => {
                  return item.count;
                }
              );
              var totalValueForPercentage = DiamondReportsChartYAxisList.reduce(
                (a, b) => a + b,
                0
              );
              setTotalDiamondClicks(totalValueForPercentage);
              var ReportDiamondChartColorList = DiamondReportsChartList.map(
                (item) => {
                  return item.DealerCompany;
                }
              );
              setTotalValueForPercentage(totalValueForPercentage);
              setDiamondReportsChartLabels(DiamondReportsChartLabelArr);
              setDiamondReportsChartYAxisList(DiamondReportsChartYAxisList);
              ReportDiamondChartsColorHandler(ReportDiamondChartColorList);
              chartDataHandler(ReportDiamondChartColorList);

              // Process data for both charts
              const { chartData: processedPieData, colors: pieColors } =
                processChartData(
                  DiamondReportsChartList,
                  DiamondReportsChartYAxisList,
                  DiamondReportsChartLabelArr
                );
              setPieChartData(processedPieData);
              setPieColorData(pieColors);

              const { chartData: processedBarData, colors: barColors } =
                processChartData(
                  DiamondReportsChartList,
                  DiamondReportsChartYAxisList,
                  DiamondReportsChartLabelArr
                );
              setBarChartData(processedBarData);
              setBarColorData(barColors);

              setKey(!key);
            }
          } else {
            setTotalDiamondClicks(0);
            setDiamondReportsChartList([]);
            setDiamondReportsChartYAxisList([]);
            setPieChartData([]);
            setBarChartData([]);
          }
        })
        .catch((error) => {
          setTotalDiamondClicks(0);
          setDiamondReportsChartList([]);
          setLoadChartReportsLoading(false);
          setDiamondReportsChartYAxisList([]);
          setDiamondReportsChartLabels([]);
          setPieChartData([]);
          setBarChartData([]);
        });
    } catch (error) {
      setTotalDiamondClicks(0);
      setDiamondReportsChartList([]);
      setLoadChartReportsLoading(false);
      setDiamondReportsChartYAxisList([]);
      setDiamondReportsChartLabels([]);
      setPieChartData([]);
      setBarChartData([]);
    }
  };

  const handleGetDiamondReportForTableChart = (dealerId, forDealer) => {
    try {
      if (
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
          "VendorDiamond" ||
        loginDetials.loginDetials.responseData.dealerMemberTypeName === "Vendor"
      ) {
        forDealer = 1;
      } else if (
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
          "Retailer" ||
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
          "Combined"
      ) {
        forDealer = 2;
      } else {
        forDealer = 3;
      }
      let inputData = {
        dealerID: dealerId.toString(),
        forDealer: forDealer ? forDealer.toString() : "",
        fromDate: globalDiamonds.dataRangeFrom
          ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: globalDiamonds.dataRangeTo
          ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
      };
      setTableChartLoading(true);
      ReportsDiamondService.GetDiamondReportForTableChart(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var TableChartList = responseData.dtData;
          setTableChartLoading(false);
          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              if (TableChartList.length > 0) {
                setTableChartList(TableChartList);
              }
            }
          } else {
            setTableChartList([]);
          }
        })
        .catch((error) => {
          setTableChartList([]);
          setTableChartLoading(false);
        });
    } catch (error) {
      setTableChartList([]);
      setTableChartLoading(false);
    }
  };

  const handleDimondChart_SortingBindData = (
    dealerId,
    forDealer,
    pageNo,
    pageSize,
    sortColumnName,
    sortOrder
  ) => {
    try {
      if (
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
          "VendorDiamond" ||
        loginDetials.loginDetials.responseData.dealerMemberTypeName === "Vendor"
      ) {
        forDealer = 1;
      } else if (
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
          "Retailer" ||
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
          "Combined"
      ) {
        forDealer = 2;
      } else {
        forDealer = 3;
      }
      let inputData = {
        dealerID: dealerId,
        forDealer: forDealer ? forDealer.toString() : "",
        orderBy: "",
        pagging: 0,
        fromDate: globalDiamonds.dataRangeFrom
          ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: globalDiamonds.dataRangeTo
          ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        lastAccessDate: globalDiamonds.dataRangeTo
          ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        noOfRows: 0,
        selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
        pageNumber: pageNo ? pageNo : 1,
        pageSize: pageSize ? pageSize : 15,
        sortOrderCol: sortColumnName || "GT.MODIFIED",
        sortOrderType: sortOrder || "DESC",
      };
      setTableForDiamChartLoading(true);
      ReportsDiamondService.DimondChart_SortingBindData(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var TableDiamondChartList = responseData.TableData?.Table;
          var TotalEventsCount =
            responseData.TableData?.Table.length > 0
              ? responseData.TableData.Table[0].TotalCount
              : 0;
          setTotalCount(TotalEventsCount);
          setTotalEventsCount(TotalEventsCount);
          setTableForDiamChartLoading(false);
          setKey(!key);
          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              setTableDiamondChartList(TableDiamondChartList);
              setEventsCount(TableDiamondChartList.length);
              setTotalEventsCount(TotalEventsCount);
            }
          } else {
            setTotalCount(0);
            setTableDiamondChartList([]);
            setEventsCount(0);
            setTotalEventsCount(0);
          }
        })
        .catch((error) => {
          setTotalCount(0);
          setTableDiamondChartList([]);
          setTableForDiamChartLoading(false);
        });
    } catch (error) {
      setTotalCount(0);
      setTableDiamondChartList([]);
      setTableForDiamChartLoading(false);
    }
  };

  const handleExportToCSV = (forDealer) => {
    try {
      if (
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
          "VendorDiamond" ||
        loginDetials.loginDetials.responseData.dealerMemberTypeName === "Vendor"
      ) {
        forDealer = 1;
      } else if (
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
          "Retailer" ||
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
          "Combined"
      ) {
        forDealer = 2;
      } else {
        forDealer = 3;
      }
      let inputData = {
        dealerID: dealerId.toString(),
        hdnFromDate: globalDiamonds.dataRangeFrom,
        hdnToDate: globalDiamonds.dataRangeTo,
        hdnPaggingRun: "",
        hdnForDealer: forDealer.toString(),
        hdnRetailerFilterId: "",
        hdnOrderBy: "",
        dealerCOMPANY: "",
        checkVendorMembership: "",
        selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
      };
      setDownloadCSVDataloading(true);
      ReportsDiamondService.ExportToCSV(inputData)
        .then((response) => {
          setDownloadCSVDataloading(false);
          var fileName =
            loginDetials.loginDetials.responseData.dealerCompany.replace(/\s+/g, "") +
            "_DiamondChartReports_" +
            new Date().toJSON().slice(0, 10).split("-").slice(1).concat(new Date().toJSON().slice(0, 4)).join("_") +
            ".csv";
          BlobToDownloadFile(response.data, fileName);
        })
        .catch((error) => {
          setDownloadCSVDataloading(false);
          console.log(error);
        });
    } catch (error) {
      setDownloadCSVDataloading(false);
      console.log(error);
    }
  };

  const handleExportToPDF = (forDealer) => {
    try {
      if (
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
          "VendorDiamond" ||
        loginDetials.loginDetials.responseData.dealerMemberTypeName === "Vendor"
      ) {
        forDealer = 1;
      } else if (
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
          "Retailer" ||
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
          "Combined"
      ) {
        forDealer = 2;
      } else {
        forDealer = 3;
      }
      let inputData = {
        dealerID: dealerId,
        forDealer: forDealer ? forDealer.toString() : "",
        fromDate: globalDiamonds.dataRangeFrom
          ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: globalDiamonds.dataRangeTo
          ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        lastAccessDate: globalDiamonds.dataRangeTo
          ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        noOfRows: 0,
        orderBy: "",
        pageNumber: 1,
        pageSize: 15,
        pagging: 0,
        selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
        sortOrderCol: "GT.MODIFIED",
        sortOrderType: "ASC",
      };
      setDownloadPDFDataloading(true);
      ReportsDiamondService.ExportTableDataToPDF(inputData)
        .then((response) => {
          setDownloadPDFDataloading(false);
          var fileName =
            "Chart" +
            new Date().toJSON().slice(0, 10).split("-").reverse().join("/") +
            ".pdf";
          BlobToDownloadFile(response.data, fileName, "pdf");
        })
        .catch((error) => {
          setDownloadCSVDataloading(false);
          console.log(error);
        });
    } catch (error) {
      setDownloadCSVDataloading(false);
      console.log(error);
    }
  };

  const handleTableASCDES = (pagination, filters, sorter) => {
    var tableBody = document.querySelector(".pendjewelreq__tbl .ant-table-body"); if (tableBody) tableBody.scrollTop = 0;
    var type = "";
    var column = "";
    //sorting
    if (sorter.order == "descend") {
      type = "DESC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else if (sorter.order == "ascend") {
      type = "ASC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else {
      type = "DESC";
      column = "GT.MODIFIED";
      setSortColumnName(column);
      setSortType(type);
    }
    setPageNo(pagination.current);
    setPageSize(pagination.pageSize);
    handleDimondChart_SortingBindData(
      dealerId,
      forDealer,
      pagination.current,
      pagination.pageSize,
      column,
      type
    );
  };
  /*API Binding Ends*/

  const ReportDiamondChartsColorHandler = (list) => {
    const color = [];
    for (let i = 0; i < list.length; i++) {
      color.push("rgb(224, 68, 14)");
    }
    setReportsDiamondChartColorData(color);
  };

  const handleOnChange = (e, isSelect, name) => {
    setGlobalDiamond({
      ...globalDiamonds,
      [name]: e,
    });
  };

  const handleApplyFilter = () => {
    handleGetDiamondColumnChartData(dealerId, forDealer);
    handleGetDiamondReportForTableChart(dealerId, forDealer);
    handleDimondChart_SortingBindData(
      dealerId,
      forDealer,
      pageNo,
      pageSize,
      sortColumnName,
      sortType
    );
  };

  // Updated chart options
  const chartOptions = {
    title: `Diamond Clicks for ${loginDetials?.loginDetials?.responseData?.dealerCompany} (${dealerId})`,
    chartArea: { width: "90%" },
    hAxis: {
      title: "Connected Vendor",
      minValue: 0,
    },
    vAxis: {
      title:
        "Diamond Clicks " +
        "(" +
        moment(globalDiamonds.dataRangeFrom).format("MM-DD-YYYY") +
        " - " +
        moment(globalDiamonds.dataRangeTo).format("MM-DD-YYYY") +
        ")",
    },
    legend: { position: "none" },
    colors: barColorData,
  };

  const pieChartOptions = {
    title: `Diamond Clicks for ${loginDetials?.loginDetials?.responseData?.dealerCompany} (${dealerId})`,
    pieHole: 0.5,
    is3D: true,
    legend: {
      position: "none",
    },
    pieSliceText: "percentage",
    pieSliceTextStyle: {
      fontSize: 12,
      color: "black",
    },
    tooltip: {
      trigger: "focus",
      isHtml: true,
    },
    sliceVisibilityThreshold: 0,
    colors: pieColorData,
    chartArea: {
      width: "100%",
      height: "100%",
    },
  };

  // Custom Legend Component
  const CustomLegend = ({ chartData, colorData, title }) => (
    <div style={{ marginBottom: "20px" }}>
      {title && (
        <div
          style={{
            textAlign: "center",
            marginBottom: "10px",
            fontWeight: "bold",
          }}
        >
          {title}
        </div>
      )}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          marginBottom: "10px",
        }}
      >
        {chartData.slice(1).map((row, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              margin: "4px 8px",
              fontSize: "13px",
              fontWeight: "500",
            }}
          >
            <div
              style={{
                width: "14px",
                height: "14px",
                backgroundColor: colorData[index],
                marginRight: "6px",
                borderRadius: "3px",
              }}
            ></div>
            {row[0].replace(/\s*\([^)]*\)\s*/g, "")} ({row[1]})
          </div>
        ))}
      </div>
    </div>
  );

 const handleDownloadPieChart = async () => {
    try {
      // Step 1: Prepare PDF-specific PieChart options
      const pdfChartOptions = {
        ...pieChartOptions,
        width: 1800,
        height: 750,
        chartArea: { left: 50, top: 20, width: "90%", height: "85%" },
        legend: { position: "none" }, // we'll add custom legend manually
        pieHole: 0.4,
        pieSliceText: "percentage",
        tooltip: { text: "percentage" },
        pieSliceTextStyle: { fontSize: 18, color: "#000" },
      };

      // Step 2: Create a hidden container
      const hiddenContainer = document.createElement("div");
      hiddenContainer.id = "pdf-temp-piechart";
      hiddenContainer.style.position = "absolute";
      hiddenContainer.style.left = "-9999px";
      hiddenContainer.style.top = "0";
      hiddenContainer.style.width = "1800px";
      hiddenContainer.style.background = "#fff";
      hiddenContainer.style.padding = "20px";
      document.body.appendChild(hiddenContainer);

      // Step 3: Create dynamic custom legends
      const legendDiv = document.createElement("div");
      legendDiv.style.display = "flex";
      legendDiv.style.flexWrap = "wrap";
      legendDiv.style.justifyContent = "space-evenly";
      legendDiv.style.marginBottom = "20px";
      legendDiv.style.fontFamily = "Arial, sans-serif";
      legendDiv.style.width = "100%";

      pieChartData.slice(1).forEach((row, index) => {
        const item = document.createElement("div");
        item.style.display = "flex";
        item.style.alignItems = "center";
        item.style.margin = "8px 16px";
        item.style.fontSize = "18px";
        item.style.fontWeight = "bold";
        item.style.whiteSpace = "nowrap";

        const colorBox = document.createElement("div");
        colorBox.style.width = "18px";
        colorBox.style.height = "18px";
        colorBox.style.backgroundColor = pieColorData[index];
        colorBox.style.marginRight = "8px";
        colorBox.style.border = "1px solid #aaa";
        colorBox.style.borderRadius = "3px";

        const labelText = row[0].replace(/\s*\([^)]*\)\s*/g, "");
        const valueText = ` (${row[1]})`;

        const textNode = document.createTextNode(labelText + valueText);
        item.appendChild(colorBox);
        item.appendChild(textNode);
        legendDiv.appendChild(item);
      });

      hiddenContainer.appendChild(legendDiv);

      // Step 4: Add chart container
      const chartDiv = document.createElement("div");
      chartDiv.style.width = "1800px";
      chartDiv.style.height = "750px";
      hiddenContainer.appendChild(chartDiv);

      // Step 5: Draw the pie chart in the hidden div
      const tempChart = new window.google.visualization.PieChart(chartDiv);
      const dataTable = window.google.visualization.arrayToDataTable(pieChartData);
      await new Promise((resolve) => {
        window.google.visualization.events.addListener(tempChart, "ready", resolve);
        tempChart.draw(dataTable, pdfChartOptions);
      });

      // Step 6: Capture legend + chart together
      const canvas = await html2canvas(hiddenContainer, {
        useCORS: true,
        scale: 2.8,
        logging: false,
      });
      const imgData = canvas.toDataURL("image/png");

      // Step 7: Clean up
      document.body.removeChild(hiddenContainer);

      // Step 8: Build PDF structure
      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 5;
      const headerHeight = 14;
      const footerHeight = 10;
      const infoBlockHeight = 20;
      const availableHeight =
        pageHeight - headerHeight - footerHeight - infoBlockHeight - 15;

      // Header
      pdf.setFillColor(31, 38, 62);
      pdf.rect(0, 0, pageWidth, headerHeight, "F");
      try {
        pdf.addImage(logoImg, "PNG", margin, 4, 40, 10);
      } catch { }

      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(14);
      pdf.setTextColor(255, 255, 255);
      pdf.text("DIAMOND CLICKS REPORT", pageWidth - margin, 11, { align: "right" });

      // Info Line (flex-like in one line)
       pdf.setFont("helvetica", "normal");
      pdf.setFontSize(9);
      pdf.setTextColor(0, 0, 0);

      const preparedFor =
        loginDetials?.impresonateData
          ? `Prepared For: ${loginDetials.impresonateData.username} (${loginDetials.impresonateData.dealerID})`
          : loginDetials?.loginDetials?.responseData
            ? `Prepared For: ${loginDetials.loginDetials.responseData.dealerCompany} (${loginDetials.loginDetials.responseData.dealerId})`
            : "Prepared For: -";

      const dateRange = `Date Range: ${moment(globalDiamonds.dataRangeFrom).format(
        "MMM DD, YYYY"
      )} - ${moment(globalDiamonds.dataRangeTo).format("MMM DD, YYYY")}`;

      const selectedDiamondLabel =
        globalDiamonds.SelectedDiamondValue === "All"
          ? "All Diamonds"
          : globalDiamonds.SelectedDiamondValue === "Mined"
            ? "Mined Diamonds"
            : "Lab Grown Diamonds";

      const diamondType = `Selected Diamond: ${selectedDiamondLabel}`;
      const clicks = `Total Clicks: ${TotalDiamondClicks?.toLocaleString() || 0}`;

      const infoLinesRaw = [
        preparedFor,
        dateRange,
        diamondType,
        clicks
      ].filter(Boolean);

      const maxWidth = pageWidth - margin * 2;

      // Split text dynamically to fit within the maxWidth
      const wrappedInfoLines = infoLinesRaw.flatMap((line) =>
        pdf.splitTextToSize(line, maxWidth)
      );

      const lineHeight = 4.8;
      let currentY = headerHeight + 5;

      // Display each line with proper spacing
      wrappedInfoLines.forEach((line) => {
        pdf.text(line, margin, currentY);
        currentY += lineHeight;
      });

      currentY += 4;

      // Chart Image
      const imgRatio = canvas.width / canvas.height;
      let imgWidthMM = pageWidth - margin * 3;
      let imgHeightMM = imgWidthMM / imgRatio;
      if (imgHeightMM > availableHeight) {
        imgHeightMM = availableHeight;
        imgWidthMM = imgHeightMM * imgRatio;
      }

      const xPos = margin;
      const yPos = currentY; 
      pdf.addImage(imgData, "PNG", xPos, yPos, imgWidthMM, imgHeightMM, undefined, "FAST");

      // Footer
      pdf.setFillColor(31, 38, 62);
      pdf.rect(0, pageHeight - footerHeight, pageWidth, footerHeight, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.setFont("helvetica", "italic");
      pdf.setFontSize(8);
      const footerText = `© ${new Date().getFullYear()} JewelCloud Inc. | Generated on ${moment().format(
        "MMM DD, YYYY h:mm A"
      )}`;
      pdf.text(footerText, pageWidth / 2, pageHeight - footerHeight / 2 + 2, {
        align: "center",
      });

      // --- WATERMARK ---
      const watermarkText = "JewelCloud";
      pdf.setFontSize(90);
      pdf.setFont(undefined, "bolditalic");
      pdf.setTextColor(102, 102, 102);

      pdf.saveGraphicsState();
      pdf.setGState(pdf.GState({ opacity: 0.1 }));

      const centerX = pageWidth / 2;
      const centerY = pageHeight / 2;

      const textWidth = pdf.getTextWidth(watermarkText);
      const textHeight =
        pdf.internal.getFontSize() / pdf.internal.scaleFactor;

      const angleRad = (45 * Math.PI) / 180;
      const rotatedWidth =
        textWidth * Math.cos(angleRad) + textHeight * Math.sin(angleRad);
      const rotatedHeight =
        textWidth * Math.sin(angleRad) + textHeight * Math.cos(angleRad);

      const xPosWatermark = centerX - rotatedWidth / 2;
      const yPosWatermark = centerY + rotatedHeight / 4 + 40;

      pdf.text(watermarkText, xPosWatermark, yPosWatermark, { angle: 45 });

      pdf.restoreGraphicsState();

      pdf.save("Diamond-Clicks-Search-Report.pdf");

    } catch (err) {
      console.error("Error generating Pie Chart PDF:", err);
    }
  };

 
    const handleDownloadBarChart = async () => {
      try {
        // Step 1: Prepare enhanced chart options for export
        const pdfChartOptions = {
          ...chartOptions,
          width: 1800, // use full width for better readability
          height: 1000,
          chartArea: {
            left: 80,
            top: 140, // more space for legend above
            bottom: 220, // increased bottom space for full vendor names
            width: "85%",
            height: "55%",
          },
          hAxis: {
            ...chartOptions.hAxis,
            slantedText: true,
            slantedTextAngle: 60, // increased angle for better text visibility
            textStyle: { fontSize: 14, color: "#333" },
            maxTextLines: 3, // allow multiple lines for long names
            maxAlternation: 1,
          },
          vAxis: {
            ...chartOptions.vAxis,
            textStyle: { fontSize: 15, color: "#333" },
          },
          annotations: {
            ...chartOptions.annotations,
            textStyle: { fontSize: 15, bold: true, color: "#000" },
          },
        };
  
        // Step 2: Create hidden container
        const hiddenContainer = document.createElement("div");
        hiddenContainer.id = "pdf-temp-chart";
        hiddenContainer.style.position = "absolute";
        hiddenContainer.style.left = "-9999px";
        hiddenContainer.style.top = "0";
        hiddenContainer.style.width = "1800px";
        hiddenContainer.style.background = "#fff";
        hiddenContainer.style.padding = "20px";
        document.body.appendChild(hiddenContainer);
  
        // Step 3: Build custom legend (larger + full width)
        const legendDiv = document.createElement("div");
        legendDiv.style.display = "flex";
        legendDiv.style.flexWrap = "wrap";
        legendDiv.style.justifyContent = "space-evenly"; // evenly spaced full width
        legendDiv.style.marginBottom = "20px";
        legendDiv.style.fontFamily = "Arial, sans-serif";
        legendDiv.style.width = "100%";
  
        barChartData.slice(1).forEach((label, index) => {
          const item = document.createElement("div");
          item.style.display = "flex";
          item.style.alignItems = "center";
          item.style.margin = "8px 16px";
          item.style.fontSize = "18px"; // larger font
          item.style.fontWeight = "bold";
          item.style.whiteSpace = "nowrap";

          const colorBox = document.createElement("div");
          colorBox.style.width = "18px";
          colorBox.style.height = "18px";
          colorBox.style.backgroundColor = barColorData[index];
          colorBox.style.marginRight = "8px";
          colorBox.style.border = "1px solid #aaa";
          colorBox.style.borderRadius = "3px";
  
          const textNode = document.createTextNode(
            `${label[0]} (${label[1]})`
          );
  
          item.appendChild(colorBox);
          item.appendChild(textNode);
          legendDiv.appendChild(item);
        });
  
        hiddenContainer.appendChild(legendDiv);
  
        // Step 4: Add chart container
        const chartDiv = document.createElement("div");
        chartDiv.style.width = "1800px";
        chartDiv.style.height = "1000px";
        hiddenContainer.appendChild(chartDiv);

        // Step 5: Draw chart
        const tempChart = new window.google.visualization.ColumnChart(chartDiv);
        const dataTable = window.google.visualization.arrayToDataTable(barChartData);
        await new Promise((resolve) => {
          window.google.visualization.events.addListener(tempChart, "ready", resolve);
          tempChart.draw(dataTable, pdfChartOptions);
        });
  
        // Step 6: Capture legend + chart together
        const canvas = await html2canvas(hiddenContainer, {
          useCORS: true,
          scale: 2.8,
          logging: false,
        });
        const imgData = canvas.toDataURL("image/png");
  
        // Step 7: Clean up
        document.body.removeChild(hiddenContainer);
  
        // Step 8: Create PDF
        const pdf = new jsPDF({
          orientation: "landscape",
          unit: "mm",
          format: "a4",
        });

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const margin = 5;
        const headerHeight = 14;
        const footerHeight = 10;
        const infoBlockHeight = 20;
        const availableHeight =
          pageHeight - headerHeight - footerHeight - infoBlockHeight - 10;
  
        // Header
        pdf.setFillColor(31, 38, 62);
        pdf.rect(0, 0, pageWidth, headerHeight, "F");
        try {
          pdf.addImage(logoImg, "PNG", margin, 4, 40, 10);
        } catch { }
  
        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(14);
        pdf.setTextColor(255, 255, 255);
        pdf.text("DIAMOND CLICKS REPORT", pageWidth - margin, 11, {
          align: "right",
        });
  
        // Info line
         pdf.setFont("helvetica", "normal");
      pdf.setFontSize(9);
      pdf.setTextColor(0, 0, 0);

      const preparedFor =
        loginDetials?.impresonateData
          ? `Prepared For: ${loginDetials.impresonateData.username} (${loginDetials.impresonateData.dealerID})`
          : loginDetials?.loginDetials?.responseData
            ? `Prepared For: ${loginDetials.loginDetials.responseData.dealerCompany} (${loginDetials.loginDetials.responseData.dealerId})`
            : "Prepared For: -";

      const dateRange = `Date Range: ${moment(globalDiamonds.dataRangeFrom).format(
        "MMM DD, YYYY"
      )} - ${moment(globalDiamonds.dataRangeTo).format("MMM DD, YYYY")}`;

      const selectedDiamondLabel =
        globalDiamonds.SelectedDiamondValue === "All"
          ? "All Diamonds"
          : globalDiamonds.SelectedDiamondValue === "Mined"
            ? "Mined Diamonds"
            : "Lab Grown Diamonds";

      const diamondType = `Selected Diamond: ${selectedDiamondLabel}`;
      const clicks = `Total Clicks: ${TotalDiamondClicks?.toLocaleString() || 0}`;

      const infoLinesRaw = [
        preparedFor,
        dateRange,
        diamondType,
        clicks
      ].filter(Boolean);

      const maxWidth = pageWidth - margin * 2;

      // Split text dynamically to fit within the maxWidth
      const wrappedInfoLines = infoLinesRaw.flatMap((line) =>
        pdf.splitTextToSize(line, maxWidth)
      );

      const lineHeight = 4.8;
      let currentY = headerHeight + 5;

      // Display each line with proper spacing
      wrappedInfoLines.forEach((line) => {
        pdf.text(line, margin, currentY);
        currentY += lineHeight;
      });

      currentY += 4;
  
        // Chart + Legend image
        const imgRatio = canvas.width / canvas.height;
        let imgWidthMM = pageWidth - margin * 3;
        let imgHeightMM = imgWidthMM / imgRatio;
        if (imgHeightMM > availableHeight) {
          imgHeightMM = availableHeight;
          imgWidthMM = imgHeightMM * imgRatio;
        }
  
        const xPos = margin;
        const yPos = currentY; 
        pdf.addImage(imgData, "PNG", xPos, yPos, imgWidthMM, imgHeightMM, undefined, "FAST");
  
        // Footer
        pdf.setFillColor(31, 38, 62);
        pdf.rect(0, pageHeight - footerHeight, pageWidth, footerHeight, "F");
        pdf.setTextColor(255, 255, 255);
        pdf.setFont("helvetica", "italic");
        pdf.setFontSize(8);
        const footerText = `© ${new Date().getFullYear()} JewelCloud Inc. | Generated on ${moment().format(
          "MMM DD, YYYY h:mm A"
        )}`;
        pdf.text(footerText, pageWidth / 2, pageHeight - footerHeight / 2 + 2, {
          align: "center",
        });
  
        // --- WATERMARK ---
          const watermarkText = "JewelCloud";
          pdf.setFontSize(90);
          pdf.setFont(undefined, "bolditalic");
          pdf.setTextColor(102, 102, 102);
  
          pdf.saveGraphicsState();
          pdf.setGState(pdf.GState({ opacity: 0.1 }));
  
          const centerX = pageWidth / 2;
          const centerY = pageHeight / 2;
  
          const textWidth = pdf.getTextWidth(watermarkText);
          const textHeight =
            pdf.internal.getFontSize() / pdf.internal.scaleFactor;
  
          const angleRad = (45 * Math.PI) / 180;
          const rotatedWidth =
            textWidth * Math.cos(angleRad) + textHeight * Math.sin(angleRad);
          const rotatedHeight =
            textWidth * Math.sin(angleRad) + textHeight * Math.cos(angleRad);
  
          const xPosWatermark = centerX - rotatedWidth / 2;
          const yPosWatermark = centerY + rotatedHeight / 4 + 40;
  
          pdf.text(watermarkText, xPosWatermark, yPosWatermark, { angle: 45 });
  
          pdf.restoreGraphicsState();
  
        pdf.save("Diamond-Clicks-Search-Report.pdf");
      } catch (err) {
        console.error("Error generating PDF:", err);
      }
    };

  return (
    <React.Fragment>
      <div className="form__fields">
        <div className="row magento__mapping">
          <div className="col-lg-12">
            <div className="heading__block">
              <h4 class="workarea__heading mt-0 mb-0">
                {""}
                {t("Diamond Charts")}
                {""}
              </h4>
            </div>
          </div>

          <div className="col-md-4">
            <div className="input__block dataRange-input-block datepicker__block">
              <label>
                {""} {t("Date Range")} {""}{" "}
              </label>
              <RangePicker
                className="date-range-input"
                ranges={{
                  Today: [moment(), moment()],
                  Yesterday: [
                    moment().subtract(1, "days"),
                    moment().subtract(1, "days"),
                  ],
                  "Last 7 Days": [moment().subtract(7, "days"), moment()],
                  "Last 30 Days": [moment().subtract(30, "days"), moment()],
                  "This Month": [
                    moment().startOf("month"),
                    moment().endOf("month"),
                  ],
                  "Last Month": [
                    moment().subtract(1, "month").startOf("month"),
                    moment().subtract(1, "months").endOf("month"),
                  ],
                  "Last 90 Days": [moment().subtract(90, "days"), moment()],
                  "Year To Date": [moment().startOf("year"), moment()],
                }}
                format={"MM-DD-YYYY"}
                onChange={onDateChange}
                defaultValue={[moment().subtract(30, "days"), moment()]}
                defaultPickerValue={[moment().subtract(30, "days"), moment()]}
              />
            </div>
          </div>

          <div className="col-md-4">
            <div className="input__block">
              <label> {t("Select Diamond")} </label>
              <Select
                className="border__grey"
                placeholder={t("All")}
                showSearch
                name="SelectedDiamondValue"
                optionFilterProp="children"
                value={
                  globalDiamonds.SelectedDiamondValue
                    ? globalDiamonds.SelectedDiamondValue
                    : null
                }
                onChange={(e) =>
                  handleOnChange(e, "select", "SelectedDiamondValue")
                }
              >
                <Option value="All">{t("All")}</Option>
                <Option value="Mined">{t("Mined Diamond")}</Option>
                <Option value="Lab">{t("Lab Grown Diamond")}</Option>
              </Select>
            </div>
          </div>

          <div className="col-lg-12 col-md-6">
            <div className="input__block">
              <label>
                <b>
                  {" "}
                  {/*{t("Total Clicks")} : {TotalDiamondClicks}{" "}*/}
                  {t("Total Clicks")} : {TotalEventsCount}{" "}
                </b>
              </label>
            </div>
          </div>

          <div className="col-md-12 mt-2">
            <div className="button__block mb-4">
              <button className="primary-btn mr-2" onClick={handleApplyFilter}>
                {" "}
                {t("Apply Filter")}{" "}
              </button>
            </div>
          </div>

          {/* Column Chart Section with Custom Legend */}
          <div className="chart__section">
            <Spin spinning={LoadChartReportsLoading} size="large">
              {barChartData.length > 1 ? (
                <>
                  <CustomLegend
                    chartData={barChartData}
                    colorData={barColorData}
                    title={t("Vendor Diamond Clicks Distribution")}
                  />
                  <div id="pdf-content-bar-chart">
                    <Chart
                      chartType="ColumnChart"
                      data={barChartData}
                      options={chartOptions}
                      width={window.innerWidth > 500 ? "100%" : 300}
                      height={window.innerWidth > 500 ? 750 : 300}
                      chartEvents={[
                        {
                          eventName: "ready",
                          callback: ({ chartWrapper }) => {
                            setBarChartInstance(chartWrapper.getChart());
                          },
                        },
                      ]}
                      ref={chartRef}
                    />
                  </div>
                </>
              ) : (
                <div className="no-report-render">
                  <div className="desc-space">
                    <h4 className="text-center">{t("No Data Found")}</h4>
                  </div>
                </div>
              )}
            </Spin>
          </div>

          {barChartData.length > 1 && (
            <div className="d-flex">
              <Button className="primary-btn" onClick={handleDownloadBarChart}>
                {" "}
                <i className="fa fa-download"></i> {t("Download Chart")}
              </Button>
            </div>
          )}

          {/* Pie Chart Section with Custom Legend */}
          <div
            className="chart__section"
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Spin spinning={LoadChartReportsLoading} size="large">
              {pieChartData.length > 1 ? (
                <>
                  <CustomLegend
                    chartData={pieChartData}
                    colorData={pieColorData}
                    title={t("Vendor Diamond Clicks Percentage")}
                  />
                  <div id="pdf-content">
                    <Chart
                      chartType="PieChart"
                      data={pieChartData}
                      width={window.innerWidth > 500 ? 800 : 300}
                      height={window.innerWidth > 500 ? 500 : 300}
                      options={pieChartOptions}
                      chartEvents={[
                        {
                          eventName: "ready",
                          callback: ({ chartWrapper }) => {
                            setPieChartInstance(chartWrapper.getChart());
                          },
                        },
                      ]}
                    />
                  </div>
                </>
              ) : (
                <div className="no-report-render">
                  <div className="desc-space">
                    <h4 className="text-center">{t("No Data Found")}</h4>
                  </div>
                </div>
              )}
            </Spin>
          </div>

          {pieChartData.length > 1 && (
            <div className="d-flex mb-3">
              <Button className="primary-btn" onClick={handleDownloadPieChart}>
                {" "}
                <i className="fa fa-download"></i> {t("Download Chart")}
              </Button>
            </div>
          )}

          <div className="heading__block">
            <h4 class="workarea__heading mt-0 mb-0">
              {t("Top Diamond Attribute Values")}
            </h4>
          </div>

          <div className="col-lg-12 col-md-12">
            <Table
              className="pendjewelreq__tbl"
                scroll={{ x: 1200, y: "calc(100vh - 340px)" }}
              loading={TableChartLoading}
              columns={[
                {
                  title: (
                    <AntdToolTip title={t("Date")}>{t("Date")}</AntdToolTip>
                  ),
                  ellipsis: true,
                  dataIndex: "Date",
                  defaultSortOrder: "descend",
                  sorter: (a, b) => {},
                },
                {
                  title: (
                    <AntdToolTip title={t("Shape")}>{t("Shape")}</AntdToolTip>
                  ),
                  ellipsis: true,
                  dataIndex: "shape",
                },
                {
                  title: (
                    <AntdToolTip title={t("Size")}>{t("Size")}</AntdToolTip>
                  ),
                  ellipsis: true,
                  dataIndex: "Size",
                },
                {
                  title: (
                    <AntdToolTip title={t("Color")}>{t("Color")}</AntdToolTip>
                  ),
                  ellipsis: true,
                  dataIndex: "Color",
                },
                {
                  title: <AntdToolTip title={t("Cut")}>{t("Cut")}</AntdToolTip>,
                  ellipsis: true,
                  dataIndex: "CutGrade",
                },
                {
                  title: (
                    <AntdToolTip title={t("Clarity")}>
                      {t("Clarity")}
                    </AntdToolTip>
                  ),
                  ellipsis: true,
                  dataIndex: "Clarity",
                },
                {
                  title: (
                    <AntdToolTip title={t("Price")}>{t("Price")}</AntdToolTip>
                  ),
                  ellipsis: true,
                  dataIndex: "Price",
                  render: (row, item) => {
                    const value = item.Price ? item.Price : "Call For Price";
                    return (
                      <AntdToolTip title={value}>
                        <span>{value}</span>
                      </AntdToolTip>
                    );
                  },
                },
              ]}
              dataSource={TableChartList}
            />
          </div>

          <div className="heading__block">
            <h4 class="workarea__heading mt-0 mb-0">
              {t("Recent Diamond Attribute Searches")}
            </h4>
          </div>

          <div className="limit_section">
            <div className="col-lg-12 mt-3">
              <div className="options__div">
                <div className="row">
                  <div className="col-lg-4 rules__div">
                    <span className="rules__txt">
                      {" "}
                      <span className="rules__txtno">
                        {EventsCount} / {TotalEventsCount}
                      </span>{" "}
                      {t("Events")}
                    </span>
                  </div>
                  <div className="col-lg-8 crud__div">
                    <Button
                      className="primary-btn"
                      onClick={() => handleExportToPDF(forDealer)}
                      loading={downloadPDFDataloading}
                    >
                      {" "}
                      <i className="fa fa-download"></i> {t("Download PDF")}
                    </Button>
                    <Button
                      className="primary-btn"
                      onClick={() => handleExportToCSV(forDealer)}
                      loading={downloadCSVDataloading}
                    >
                      {" "}
                      <i className="fa fa-download"></i> {t("Download CSV")}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-12 col-md-12">
            <Table
              className="pendjewelreq__tbl"
                scroll={{ x: 1200, y: "calc(100vh - 340px)" }}
              loading={TableForDiamChartLoading}
              columns={[
                {
                  title: (
                    <AntdToolTip title={t("IPAddress")}>
                      {t("IPAddress")}
                    </AntdToolTip>
                  ),
                  ellipsis: true,
                  dataIndex: "UsersIPAddress",
                  sorter: (a, b) => {},
                  render: (row, item) => {
                    if (Object.keys(item.UsersIPAddress).length !== 0) {
                      return (
                        <React.Fragment>
                          <span>{item.UsersIPAddress}</span>
                        </React.Fragment>
                      );
                    }
                  },
                },
                {
                  title: (
                    <AntdToolTip title={t("Stock #")}>
                      {t("Stock #")}
                    </AntdToolTip>
                  ),
                  ellipsis: true,
                  dataIndex: "DealerStockNo",
                  sorter: (a, b) => {},
                  render: (row, item) => {
                    if (Object.keys(item.DealerStockNo).length !== 0) {
                      return (
                        <React.Fragment>
                          <span>{item.DealerStockNo}</span>
                        </React.Fragment>
                      );
                    }
                  },
                },
                {
                  title: (
                    <AntdToolTip title={t("Dealer Company")}>
                      {t("Dealer Company")}
                    </AntdToolTip>
                  ),
                  ellipsis: true,
                  dataIndex: "DealerCompany",
                  sorter: (a, b) => {},
                  render: (row, item) => {
                    if (Object.keys(item.DealerCompany).length !== 0) {
                      return (
                        <React.Fragment>
                          <span>{item.DealerCompany}</span>
                        </React.Fragment>
                      );
                    }
                  },
                },
                {
                  title: (
                    <AntdToolTip title={t("Shape")}>{t("Shape")}</AntdToolTip>
                  ),
                  ellipsis: true,
                  dataIndex: "Cut",
                  sorter: (a, b) => {},
                  render: (row, item) => {
                    if (Object.keys(item.Cut).length !== 0) {
                      return (
                        <React.Fragment>
                          <span>{item.Cut}</span>
                        </React.Fragment>
                      );
                    }
                  },
                },
                {
                  title: (
                    <AntdToolTip title={t("Size")}>{t("Size")}</AntdToolTip>
                  ),
                  ellipsis: true,
                  dataIndex: "Size",
                  sorter: (a, b) => {},
                  render: (row, item) => {
                    if (Object.keys(item.Size).length !== 0) {
                      return (
                        <React.Fragment>
                          <span>{item.Size}</span>
                        </React.Fragment>
                      );
                    }
                  },
                },
                {
                  title: <AntdToolTip title={t("Cut")}>{t("Cut")}</AntdToolTip>,
                  ellipsis: true,
                  dataIndex: "CutGrade",
                  sorter: (a, b) => {},
                  render: (row, item) => {
                    if (Object.keys(item.CutGrade).length !== 0) {
                      return (
                        <React.Fragment>
                          <span>{item.CutGrade}</span>
                        </React.Fragment>
                      );
                    }
                  },
                },
                {
                  title: (
                    <AntdToolTip title={t("Color")}>{t("Color")}</AntdToolTip>
                  ),
                  ellipsis: true,
                  dataIndex: "Color",
                  sorter: (a, b) => {},
                  render: (row, item) => {
                    if (Object.keys(item.Color).length !== 0) {
                      return (
                        <React.Fragment>
                          <span>{item.Color}</span>
                        </React.Fragment>
                      );
                    }
                  },
                },
                {
                  title: (
                    <AntdToolTip title={t("Clarity")}>
                      {t("Clarity")}
                    </AntdToolTip>
                  ),
                  ellipsis: true,
                  dataIndex: "Clarity",
                  sorter: (a, b) => {},
                  render: (row, item) => {
                    if (Object.keys(item.Clarity).length !== 0) {
                      return (
                        <React.Fragment>
                          <span>{item.Clarity}</span>
                        </React.Fragment>
                      );
                    }
                  },
                },
                {
                  title: (
                    <AntdToolTip title={t("Cert")}>{t("Cert")}</AntdToolTip>
                  ),
                  ellipsis: true,
                  dataIndex: "Certificate",
                  sorter: (a, b) => {},
                  render: (row, item) => {
                    if (Object.keys(item.Certificate).length !== 0) {
                      return (
                        <React.Fragment>
                          <span>{item.Certificate}</span>
                        </React.Fragment>
                      );
                    }
                  },
                },
                {
                  title: (
                    <AntdToolTip title={t("Price")}>{t("Price")}</AntdToolTip>
                  ),
                  ellipsis: true,
                  dataIndex: "WholesalePrice",
                  sorter: (a, b) => {},
                  render: (row, item) => {
                    const value = item.WholesalePrice ? item.WholesalePrice : "Call For Price";
                    return (
                      <AntdToolTip title={value}>
                        <span>{value}</span>
                      </AntdToolTip>
                    );
                  },
                },
                {
                  title: (
                    <AntdToolTip title={t("Day & Time")}>
                      {t("Day & Time")}
                    </AntdToolTip>
                  ),
                  ellipsis: true,
                  dataIndex: "Modified",
                  defaultSortOrder: "descend",
                  sorter: (a, b) => {
                    return new Date(a.Modified) - new Date(b.Modified);
                  },
                  render: (value, record) => {
                    const isValidDate =
                      value && Object.keys(value).length !== 0;
                    if (!isValidDate) return null;

                    const formattedDate = moment(value).format(
                      "MM-DD-YYYY, hh:mm:ss A"
                    );

                    return (
                      <AntdToolTip title={formattedDate}>
                        <span>{formattedDate}</span>
                      </AntdToolTip>
                    );
                  },
                },
              ]}
              dataSource={TableDiamondChartList}
              pagination={{
                size: "small",
                total: totalCount,
                pageNo: pageNo,
                pageSize: pageSize,
                pageSizeOptions: [10, 15, 20, 50, 100],
                responsive: true,
                showSizeChanger: true,
              }}
              onChange={handleTableASCDES}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondReportsChartsIndComp;
